module.exports = __webpack_public_path__ + "img/logo-new.72b40339.svg";